import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import Button from "../../components/button/Button";
import TopButton from "../../components/topButton/TopButton";
import { Fade } from "react-reveal";
import {
  greeting,
  projectsHeader,
  publications,
  profileHeader,
} from "../../portfolio.js";
import "./Profile.css";

class Profile extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="profile-main">
        <Header theme={theme} />
        <div className="basic-projects">
          <Fade bottom duration={2000} distance="40px">
            <div className="projects-heading-div">
              <div className="projects-heading-text-div">
                <h1
                  className="projects-heading-text"
                  style={{ color: theme.text }}
                >
                  {profileHeader.title}
                </h1>
                <p
                  className="projects-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {profileHeader["description"]}
                </p>
              </div>
              <div className="projects-heading-img-div">
                <img
                  src={require(`../../assests/images/${projectsHeader["avatar_image_path"]}`)}
                  alt=""
                />
                {/* <ProjectsImg theme={theme} /> */}
              </div>
            </div>
          </Fade>
        </div>

        <Button
          text={"More Profile Details"}
          className="project-button"
          href={greeting.githubProfile}
          newTab={true}
          theme={theme}
        />
        {/* Publications  */}
        {publications.data.length > 0 ? (
          <div className="basic-projects">
            <Fade bottom duration={2000} distance="40px">
              <div>First Name </div>
              <div>Last Name </div>
              <div>Country </div>
              <div>Province </div>
              <div>Phone</div>
              <div>Email Address </div>
            </Fade>
          </div>
        ) : null}
        {/*  Removing but keeping for later
        <div className="repo-cards-div-main">
          {publications.data.map((pub) => {
            return <PublicationCard pub={pub} theme={theme} />;
          })}
        </div>
        */}
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Profile;
